import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-modal-planning-hq-warning',
  templateUrl: './modal-planning-hq-warning.component.html',
  styles: []
})
export class ModalPlanningHqWarningComponent extends ExcTranslation implements OnInit {

  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef) {
    super();
  }

  proceed() {
    this.overlayRef.close({proceed: true});
  }

  ngOnInit() {
  }

}
